// src/utils/helpers.js
export const getCurrentTime = () => {
  const now = new Date();
  return now.toLocaleString('en-US', { weekday: 'long', hour: 'numeric', minute: '2-digit', hour12: true });
};

export const truncateTitle = (title, maxLength = 50) => {
  if (title.length <= maxLength) return title;
  return title.substring(0, maxLength - 3) + '...';
};